import { render, staticRenderFns } from "./files-sheet.vue?vue&type=template&id=203f7dfa&scoped=true"
import script from "./files-sheet.vue?vue&type=script&lang=ts"
export * from "./files-sheet.vue?vue&type=script&lang=ts"
import style0 from "./files-sheet.vue?vue&type=style&index=0&id=203f7dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203f7dfa",
  null
  
)

export default component.exports